// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Componentes base
import './components'

// Plugins
import './plugins'
import JsonExcel from 'vue-json-excel'
import * as VueGoogleMaps from "vue2-google-maps";

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import router from '@/router'
import store from '@/store'

const maps = {
  load: {
    key: "AIzaSyCh-eiuZtWQG5Ez2IseBGzE_I9E2FA3M50"
  }
}

// Sync store with router
sync(store, router)

Vue.component('downloadExcel', JsonExcel)
Vue.use(VueGoogleMaps, maps);
Vue.config.productionTip = false

/* Ejecucion de vistas */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
